import React from "react";
import { createAvtarName, hasImage } from "../../../../utils";
import Avatar from "../../../../components/Avatar/index";

export const BoardAvatar = ({ boardData }) => {
  return (
    <div className="d-flex align-items-center">
      <Avatar
        key={`board-avtar-${boardData.board_id}`}
        user_image={boardData.board_owner_image}
        className="sidebar-boardData-owner board-user-avatar"
        title={boardData.board_owner_name}
        style={
          !hasImage(boardData.board_owner_image) && {
            bgcolor: boardData?.board_owner_profile_color?.background,
            color: boardData?.board_owner_profile_color?.text,
          }
        }>
        {`${createAvtarName(boardData.board_owner_name)}`.toUpperCase()}
      </Avatar>

      <p className="worklog_board_name ml-2">{boardData.board_name}</p>
    </div>
  );
};
